export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '')
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

export function useUpload() {
  const { executeRecaptchaTokens } = useGoogleRecaptcha()

  async function uploadFiles(files, kind = 'resume') {
    if (!files?.length)
      return []
    const [token] = await executeRecaptchaTokens('upload', 1)
    const payload = await Promise.all(Array.from(files, async file => ({ name: file.name, data: await toBase64(file) })))
    const response = await $fetch('/api/upload', { method: 'POST', body: { token, kind, files: payload } })
    return response.files
  }

  return { uploadFiles }
}
